import type { BrandConfig } from "../index";

// PLACEHOLDER brand. Tożsamość (teksty, dane firmy, linki) i assety do uzupełnienia.
// Kolory youlook = LAVMAG na razie (mogą się zmienić) — definiowane w themes.css.
// Realne, znane różnice youlook to TOKENY KSZTAŁTU w themes.css, nie ten plik.
export const youlookBrand: BrandConfig = {
  id: "youlook",
  name: "YouLook",
  currency: "PLN",
  freeShippingThreshold: 159,
  siteUrl: "https://youlook.pl",
  cdnHost: "images.lavmag.eu",
  returnsUrl: "https://wygodnezwroty.pl/youlook",
  returnsWithdrawalUrl: "https://wygodnezwroty.pl/youlook/odstapienie",
  // Hidy integracji WZ (baner /zwroty + badge stopki) siedzą w inventory —
  // host_vars/prestashop-rest-front-youlook-host/config.yaml. Tu ich nie ma,
  // żeby nie mieć dwóch źródeł prawdy (env wygrywa z kodem).
  logo: { src: "/brands/youlook/logo.svg" },
  favicon: {
    svg: "/brands/youlook/favicon.svg",
    ico: "/brands/youlook/favicon.ico",
    appleTouchIcon: "/brands/youlook/apple-touch-icon-180.png",
  },
  footer: {
    address: "Tarnawa Mała 45a",
    postalCode: "23-465",
    city: "Turobin",
    country: "Polska",
    email: "kontakt@youlook.pl",
    phone: "+48 530 073 129",
    copyrightName: "YouLook",
    createdBy: "contelizer.pl",
    legalName: "YouLook Krzysztof Matyjaszek",
    // Siedziba (miejscownik) do klauzuli RODO — post-miasto rejestrowe (budynek: Tarnawa Mała 45a).
    // Dane rejestrowe: NIP 918 207 94 88, REGON 061661139 (do regulaminu/pełnej stopki gdy powstanie renderer).
    legalSeat: "Turobinie",
    serviceHours: "8:00 – 14:00",
    // Linki kategorii youlook — ID z backendu youlook. Sekcje: Kobieta /
    // Mężczyzna / Obuwie / Dziecko (bez „Dom i Ogród”, którego youlook nie ma).
    links: [
      { label: "Kobieta", href: "/103-odziez-damska" },
      { label: "Mężczyzna", href: "/371-odziez-meska" },
      { label: "Obuwie", href: "/311-obuwie" },
      { label: "Dziecko", href: "/5135-odziez" },
      { label: "Marki", href: "/marki" },
    ],
  },
  social: {
    facebook: "https://www.facebook.com/YouLook.online",
    instagram: "https://www.instagram.com/youlook.online",
  },
  seo: {
    titleTemplate: "%s · YouLook",
    defaultTitle: "YouLook - odzież i buty znanych marek 70% taniej",
    defaultDescription:
      "Kupuj produkty znanych marek do 70% taniej w naszym sklepie online! Oferujemy szeroki wybór ubrań, butów i akcesoriów od najlepszych producentów w atrakcyjnych cenach. Sprawdź naszą ofertę i przekonaj się, że zakupy w naszym sklepie to dobry wybór!",
    ogImage: "/brands/youlook/og-image.png",
    themeColor: "#151515",
  },
  pwa: {
    name: "YouLook - odzież i buty znanych marek 70% taniej",
    shortName: "YouLook",
    description:
      "Kupuj produkty znanych marek do 70% taniej w naszym sklepie online! Oferujemy szeroki wybór ubrań, butów i akcesoriów od najlepszych producentów w atrakcyjnych cenach. Sprawdź naszą ofertę i przekonaj się, że zakupy w naszym sklepie to dobry wybór!",
    // Wygenerowane z public/brands/youlook/favicon.svg (monogram „YL" na jasnym tle,
    // w bezpiecznej strefie maskable). Screenshoty pominięte — brak assetów youlook.
    icons: [
      { src: "/brands/youlook/pwa-icons/icon-192.png", sizes: "192x192", type: "image/png", purpose: "any" },
      { src: "/brands/youlook/pwa-icons/icon-512.png", sizes: "512x512", type: "image/png", purpose: "any" },
      { src: "/brands/youlook/pwa-icons/icon-maskable-512.png", sizes: "512x512", type: "image/png", purpose: "maskable" },
    ],
  },
  // youlook używa bramki Tpay (lavmag zostaje na Przelewy24). BLIK wspólny.
  paymentLogos: [
    { src: "/images/brands/blik.svg", alt: "BLIK", width: 42, height: 20 },
    { src: "/images/brands/tpay.svg", alt: "Tpay", width: 47, height: 20 },
  ],
  // Opinie o sklepie z Zaufane.pl (white-label eKomi) — własne konto youlook,
  // nie lavmag: profil zaufane.pl/opinie/youlook, eKomi shop ID 156127.
  // `ekomiCertificateId` = „Identyfikator partnera" ze strony certyfikatu.
  reviews: {
    ekomiCertificateId: "B6A41AA0DF9A4FB",
    profileUrl: "https://www.ekomi-pl.com/opinie-f6d5f1f511056abe93d8c2eac4b46f11.html",
  },
  variants: {
    newsletterLayout: "youlook",
  },
  // Prośba youlooka 26.10.2026: 40% zamiast 20% do 15.11 włącznie (Black Weeks),
  // potem sekcja sama wraca do 20%.
  newsletterDiscount: {
    percent: 20,
    promo: { percent: 40, until: "2026-11-16T00:00:00+01:00" },
  },
  // Landing /newsletter pod reklamy Black Weeks (26.10.2026): grafika i tekst od
  // klienta, zapisy zbierane w edrone w osobnej grupie po tagu.
  newsletterCampaign: {
    title: "Black Weeks nadchodzą",
    text: "Dołącz do listy VIP i odbierz rabat do -40% przed wszystkimi. Zapisani dostaną dostęp do promocji jako pierwsi, zanim najlepsze rozmiary znikną.",
    cta: "Dołącz teraz",
    // Zapis z tego formularza podpina edrone po swojej stronie (One-Click) —
    // uzgodnione z edrone 28.10.2026, nasze zdarzenie zostało odpięte.
    edroneTag: null,
    image: {
      square: { src: "/brands/youlook/newsletter/black-weeks-square.webp", width: 1081, height: 1080 },
      vertical: { src: "/brands/youlook/newsletter/black-weeks-vertical.webp", width: 1081, height: 1920 },
      share: "/brands/youlook/newsletter/black-weeks-share.jpg",
      alt: "YouLook Black Weeks nadchodzą — dołącz do listy VIP i odbierz wyjątkowy rabat -40%",
    },
  },
  // Akcja „Im więcej kupujesz, tym więcej zyskujesz" — odpowiednik lavmagowych EXTRA,
  // ale kody MORE* i własne progi (ustalone przez klienta 2026-08-04). Kolor akcji to
  // limonkowa zieleń #008000 (ta sama, którą dostaje belka u góry i banery w PrestaShop);
  // tekst biały, bo #008000 jest ciemne, a najwyższy próg wyróżniony jasną żółcią.
  // startsAt: null = akcja rusza od razu po wdrożeniu (klient nie podał daty startu).
  standingPromo: {
    startsAt: null,
    accent: { bg: "#008000", text: "#ffffff", best: "#fff881" },
    codes: [
      { code: "MORE10", pct: "-10%", from: "100 PLN" },
      { code: "MORE15", pct: "-15%", from: "150 PLN" },
      { code: "MORE20", pct: "-20%", from: "200 PLN" },
      { code: "MORE25", pct: "-25%", from: "250 PLN" },
      { code: "MORE30", pct: "-30%", from: "320 PLN" },
    ],
  },
};
